import { render, staticRenderFns } from "./blogOverview.vue?vue&type=template&id=27b04ebe&scoped=true&"
import script from "./blogOverview.vue?vue&type=script&lang=js&"
export * from "./blogOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b04ebe",
  null
  
)

export default component.exports